module.exports = __webpack_public_path__ + "img/visa.935976c8.jpg";